
/**
 * Iniciliaza a função js para a input
 */
function CustomFileInput() {
  const wrapperFileInputs = document.querySelectorAll('[data-custom-file-input]');

  if (!wrapperFileInputs.length) {
    return;
  }

  settings(wrapperFileInputs)
}

/**
 * Incializa os listeners para os lementos de upload de
 * arquivos selecionados na página
 * @param {array} wrapperFileInputs
 */
function settings(wrapperFileInputs) {
  wrapperFileInputs.forEach(wrapperFileInput => {
    const fileInput = wrapperFileInput.querySelector('.input-file__input');
    const fileLabel = wrapperFileInput.querySelector('.input-file__label');
    const fileSelected = wrapperFileInput.querySelector('.input-file__selected');

    applyListenersLabel(fileLabel, fileInput);
    applyListenerFileInput(fileInput, fileSelected);
  });
}

/**
 * Aplicando o listener para a label da input de arquivo
 * @param {Element} fileLabel
 * @param {Element} fileInput
 */
function applyListenersLabel(fileLabel, fileInput) {
  fileLabel.addEventListener('keydown', (event) => {
    if (event.keyCode == 13 || event.keyCode == 32) {
      fileInput.focus();
    }
  });

  fileLabel.addEventListener('click', (event) => {
    fileInput.focus();
    return false;
  });
}

/**
 * Apliucando o listener para a input de arquivo,
 * quando um arquivo é selecionado
 *
 * @param {Element} fileInput
 * @param {Element} fileSelected
 */
function applyListenerFileInput(fileInput, fileSelected) {
  fileInput.addEventListener('change', () => {
    fileSelected.innerHTML = fileInput.files[0].name;
  });
}

exports.init = CustomFileInput;
